import {
  NgModule
} from '@angular/core';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {
  DateInputsModule
} from '@progress/kendo-angular-dateinputs';
import {
  DropDownsModule
} from '@progress/kendo-angular-dropdowns';
import {
  InputsModule, RadioButtonModule
} from '@progress/kendo-angular-inputs';
import {
  SharedCommonModule
} from '../shared/common';
import {
  LoadingIndicatorModule
} from '../shared/layout/components/loading-indicator';
import {BreadcrumbModule} from '../shared/layout/components/breadcrumb';
import {GridModule} from '@progress/kendo-angular-grid';
import {ReactiveFormsModule} from '@angular/forms';
import {DialogModule} from '@progress/kendo-angular-dialog';
import {MatDialogModule, MatExpansionPanel, MatIconModule} from '@angular/material';
import {FlexLayoutModule} from '@angular/flex-layout';
import { UploadModule } from '@progress/kendo-angular-upload';
import {TitleCasePipe} from '@angular/common';
import {LiveSessionComponent} from './live-session.component';
import {FileViewerDialogComponent} from './components/file-viewer-dialog.component';
import {PrescriptionDialogComponent} from './components/prescription-dialog.component';
import {ImageViewerDialogComponent} from './components/image-viewer-dialog.component';
import {SchedulerModule} from '@progress/kendo-angular-scheduler';
import {NoteDialogComponent} from '../clients/components/note-dialog.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {FloatingLabelModule} from '@progress/kendo-angular-label';
import {ProductListComponent} from '../product-list/product-list.component';
import {ScrollViewModule} from '@progress/kendo-angular-scrollview';
import {ShopifyService} from '../services/shopify/shopify.service';
import {CollectionService} from '../services/shopify/collection.service';
import {ProductComponent} from '../product/product.component';
import {VariantModule} from '../products/variant.module';
import {TreeViewModule} from '@progress/kendo-angular-treeview';
import {AppointmentService} from '../services/appointment/appointment.service';
import {DealItemDetailComponent} from './components/deal-item-detail.component';
import {DealItemDetailModule} from './components/deal-item-detail.module';
import {TooltipModule} from '@progress/kendo-angular-tooltip';

@NgModule({
  declarations: [
    LiveSessionComponent,
    ProductListComponent,
    ProductComponent
  ],
  imports: [
    ButtonsModule,
    DateInputsModule,
    GridModule,
    DropDownsModule,
    InputsModule,
    RadioButtonModule,
    LoadingIndicatorModule,
    SchedulerModule,
    TreeViewModule,
    MatExpansionModule,
    FloatingLabelModule,
    ScrollViewModule,
    BreadcrumbModule,
    DealItemDetailModule,
    TooltipModule,
    SharedCommonModule,
    ReactiveFormsModule,
    DialogModule,
    UploadModule,
    MatDialogModule,
    MatIconModule,
    FlexLayoutModule,
    VariantModule,
  ],
  exports: [
  ],
  providers: [
    TitleCasePipe,
    ShopifyService,
    CollectionService,
    AppointmentService
  ],
  entryComponents: [
    FileViewerDialogComponent,
    PrescriptionDialogComponent,
    ImageViewerDialogComponent,
    NoteDialogComponent
  ],
})
export class LiveSessionModule {
}
